import React from 'react';
import { TeamMember } from '../types';

interface TeamSectionProps {
  members: TeamMember[];
}

export const TeamSection: React.FC<TeamSectionProps> = () => {
  return (
    <section id="team" className="py-32 bg-background relative border-t border-gray-100">
      <div className="max-w-5xl mx-auto px-6">
        <div className="bg-white rounded-lg border border-gray-200 shadow-2xl overflow-hidden font-mono text-xs md:text-sm code-shadow">
          <div className="bg-gray-100 px-4 py-2 flex items-center justify-between border-b border-gray-200">
            <div className="flex gap-2">
              <div className="w-3 h-3 rounded-full bg-red-400 border border-red-500/20" />
              <div className="w-3 h-3 rounded-full bg-yellow-400 border border-yellow-500/20" />
              <div className="w-3 h-3 rounded-full bg-green-400 border border-green-500/20" />
            </div>
            <div className="text-gray-600 text-xs font-medium flex items-center gap-2 overflow-hidden px-4">
              <span className="opacity-50 truncate">src/Ayum.Team/</span>
              <span className="whitespace-nowrap">Members.cs</span>
            </div>
            <div className="w-10" />
          </div>

          <div className="p-6 text-gray-800 bg-white overflow-x-auto">
            <div className="flex min-w-[420px]">
              <div className="flex flex-col text-right pr-4 text-gray-300 select-none border-r border-gray-100 mr-4 text-[10px] md:text-xs leading-6 shrink-0">
                {Array.from({ length: 12 }).map((_, index) => (
                  <span key={index} className="block h-6">
                    {index + 1}
                  </span>
                ))}
              </div>

              <div className="font-medium text-[11px] md:text-sm leading-6 whitespace-pre">
                <span>
                  <span className="text-syntaxKeyword font-bold">namespace</span> Ayum.Team;
                </span>
                <br />
                <br />
                <span>
                  <span className="text-syntaxKeyword font-bold">public static class</span>{' '}
                  <span className="text-syntaxType">Members</span>
                </span>
                <br />
                <span className="text-gray-400">{'{'}</span>
                <br />
                <span>
                  {'    '}
                  <span className="text-syntaxKeyword font-bold">public static readonly string[]</span>{' '}
                  <span className="text-syntaxVariable">All</span> =
                </span>
                <br />
                <span>
                  {'    '}
                  <span className="text-gray-400">{'{'}</span>
                </span>
                <br />
                <span>
                  {'        '}
                  <span className="text-syntaxString">"Jesse"</span>,
                </span>
                <br />
                <span>
                  {'        '}
                  <span className="text-syntaxString">"Jesiel Ann"</span>,
                </span>
                <br />
                <span>
                  {'        '}
                  <span className="text-syntaxString">"Emmanuel"</span>,
                </span>
                <br />
                <span>
                  {'        '}
                  <span className="text-syntaxString">"Mary Grace"</span>
                </span>
                <br />
                <span>
                  {'    '}
                  <span className="text-gray-400">{'}'}</span>;
                </span>
                <br />
                <span className="text-gray-400">{'}'}</span>
              </div>
            </div>
          </div>

          <div className="bg-[#007acc] text-white px-3 py-1 text-xs flex justify-between items-center">
            <div className="flex gap-4">
              <span>main</span>
              <span>0 errors</span>
              <span>0 warnings</span>
            </div>
            <div className="flex gap-4">
              <span>Ln 12, Col 1</span>
              <span>UTF-8</span>
              <span>C#</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
